import { render, staticRenderFns } from "./FrzReportHeavy.vue?vue&type=template&id=509d7898"
import script from "./FrzReportHeavy.vue?vue&type=script&lang=js"
export * from "./FrzReportHeavy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports